import { render, staticRenderFns } from "./GetAllMenu.vue?vue&type=template&id=1f1616f6&"
import script from "./GetAllMenu.vue?vue&type=script&lang=js&"
export * from "./GetAllMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports